import React, { useState } from "react";
import {  IconChevronDown } from '@tabler/icons-react';
import { motion, AnimatePresence } from "framer-motion";

const faqData = [
    {
        question: "What is the main difference between CNC milling and turning? ",
        answer: "Both are CNC machining processes but serve different purposes. CNC turning rotates the material while a cutting tool shapes it—ideal for cylindrical parts. CNC milling, on the other hand, uses a rotating tool to remove material from a stationary workpiece—perfect for complex surfaces and features. At GXL, we offer both to ensure optimal precision and flexibility for your project. ",
    },
    {
        question: "Which method is better for high-precision components? ",
        answer: "For extremely tight tolerances (±0.005mm), EDM (Electrical Discharge Machining) and surface grinding are often preferred. EDM is excellent for intricate cuts in hard materials, while grinding ensures ultra-flat finishes. GXL selects the best technique—or combination—for your part's material, geometry, and performance requirements. ",
    },
    {
        question: "Which process is more cost-effective for prototyping? ",
        answer: "CNC machining is typically more cost-effective for low-volume prototyping due to its speed, flexibility, and lack of tooling costs. For complex shapes or hard-to-machine materials, Wire EDM can be more efficient. GXL helps you strike the right balance between precision, speed, and cost in every prototype build.",
    }
];

const Faq = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <section className='bg-[#E4E5E7] lg:py-16 py-10'>
            <div className='container lg:px-10 px-6 max-w-[1600px] mx-auto'>
                <div className="grid md:grid-cols-9 grid-cols-1 md:gap-4 gap-4 lg:mt-10 mt-6">
                    <div className='md:col-span-4  space-y-4'>
                        <h2 className='text-gray-800 lg:text-5xl text-start text-3xl font-medium '>
                            Frequently asked questions
                        </h2>
                    </div>
                    <div className='md:col-span-5'>
                        <div className="space-y-4">
                            {faqData.map((faq, index) => {
                                const isOpen = activeIndex === index;
                                return (
                                    <div key={index} className="border-b border-b-[#000]/30 pb-4">
                                        <div
                                            className="flex justify-between items-center cursor-pointer"
                                            onClick={() => toggleFAQ(index)}
                                        >
                                            <h3 className='text-left md:text-xl text-lg font-medium leading-normal tracking-tighter text-black'>
                                                {faq.question}
                                            </h3>
                                            <motion.div
                                                animate={{ rotate: isOpen ? 180 : 0 }}
                                                transition={{ duration: 0.3 }}
                                            >
                                                <IconChevronDown stroke={2} />
                                            </motion.div>
                                        </div>

                                        <AnimatePresence>
                                            {isOpen && (
                                                <motion.div
                                                    initial={{ opacity: 0, height: 0 }}
                                                    animate={{ opacity: 1, height: "auto" }}
                                                    exit={{ opacity: 0, height: 0 }}
                                                    transition={{ duration: 0.3 }}
                                                >
                                                    <p className="mt-3 text-base text-black">
                                                        {faq.answer}
                                                    </p>
                                                </motion.div>
                                            )}
                                        </AnimatePresence>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Faq;
